import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class ParishOrganizationService {
  constructor(private http: HttpClient, private api: AppConfig) {}

  findParishOrganization(page = 1, perPage = 50, sort = 'createdAt', direction = 'desc', search = '') {
    return this.http.get(
      `${this.api.baseUrl}/parishOrganization/parishOrganizations?page=${page}&perPage=${perPage}&sort=${sort}&direction=${direction}&search=${search}`,
      this.api.jsonTokenHeaders
    );
  }

  deleteParishOrganization(id: string | number) {
    return this.http.delete(
      `${this.api.baseUrl}/parishOrganization/deleteParishOrganization?id=${id}`,
      this.api.jsonTokenHeaders
    );
  }

  addParishOrganization(body: any) {
    return this.http.post(
      `${this.api.baseUrl}/parishOrganization/addParishOrganization`,
      body,
      this.api.jsonTokenHeaders
    );
  }

  findById(id: string | number) {
    return this.http.get(
      `${this.api.baseUrl}/parishOrganization/parishOrganization?id=${id}`,
      this.api.jsonTokenHeaders
    );
  }

  parishOrganizationsOpen() {
    return this.http.get(
      `${this.api.baseUrl}/parishOrganization/parishOrganizationsOpen`,
      this.api.jsonTokenHeaders
    );
  }

  updateParishOrganization(body: any) {
    return this.http.post(
      `${this.api.baseUrl}/parishOrganization/updateUserParishOrganization`,
      body,
      this.api.jsonTokenHeaders
    );
  }

  getByFrontUserId(frontUserId: number) {
    return this.http.get<{ parishOrganizationId: number; activityId: number }[]>(
      `${this.api.baseUrl}/frontUserParishOrg/getByFrontUserId?frontUserId=${frontUserId}`,
      this.api.jsonTokenHeaders
    );
  }

  saveFrontUserParishOrgs(frontUserId: number, body: { parishOrganizationId: number; activityId: number }[]) {
    return this.http.post(
      `${this.api.baseUrl}/frontUserParishOrg/save?frontUserId=${frontUserId}`,
      body,
      this.api.jsonTokenHeaders
    );
  }
}
